import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-df36fcf0")
const _hoisted_1 = { class: "item" }
const _hoisted_2 = {
  key: 0,
  class: "line_1 flex"
}
const _hoisted_3 = {
  key: 1,
  class: "line_2 flex"
}
const _hoisted_4 = { class: "blod" }
const _hoisted_5 = { class: "line_3" }
const _hoisted_6 = {
  key: 2,
  class: "line_3"
}
const _hoisted_7 = {
  key: 3,
  class: "line_3"
}
const _hoisted_8 = {
  key: 4,
  class: "line_3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "line_6 flex" }, [
  /*#__PURE__*/_createElementVNode("div", null, "商品"),
  /*#__PURE__*/_createElementVNode("div", null, "数量")
], -1)
const _hoisted_10 = { class: "line_7 flex" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "number" }
const _hoisted_13 = {
  key: 5,
  class: "line_8 flex"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1)
_popScopeId()

import { ref, onMounted, } from "vue"

export default /*#__PURE__*/_defineComponent({
  props: {
	initData: Array,
	file: Object,
	setData: Object
},
  setup(__props) {

const props = __props


let dataList = ref<any>([])
const renderPage = (file: any) => {
	dataList.value = file.map((item: any) => {
		let obj: any = {
			groupCode: item['跟团号'],
			orderCode: item['订单号'],
			orderingPerson: item['下单人'],
			memberRemark: item['团员备注'],
			paymentTime: item['支付时间'],
			leaderRemark: item['团长备注'],
			goods: item['商品'],
			count: item['数量'],
			verified: item['已核销'],
			waitVerification: item['待核销'],
			orderAmount: item['商品金额'],
			refundAmount: item['退款金额'],
			orderStatus: item['订单状态'],
			leader: item['团长'],
			location: item['自提点'],
			locationPerson: item['自提点联系人'],
			locationPhone: item['自提点电话'],
			locationAdress: item['自提点地址'],
			consignee: item['收货人'],
			address: item['详细地址'],
		}
		obj.phone = item['联系电话'] ? item['联系电话'].slice(0, 3) + item['联系电话'].slice(3, 7).replace(/./g, '*') + item['联系电话'].slice(7, Infinity) : ''
		return obj
	})
}
onMounted(() => {
	renderPage(props.initData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "list",
        key: index
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.setData.orderStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, "顾客自提-" + _toDisplayString(item.orderStatus), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.setData.leader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.groupCode), 1),
                _createElementVNode("div", null, _toDisplayString(item.orderingPerson), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, " 团长：" + _toDisplayString(item.leader), 1),
          (__props.setData.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 提货点：" + _toDisplayString(item.location), 1))
            : _createCommentVNode("", true),
          (__props.setData.consignee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 联系人：" + _toDisplayString(item.consignee) + " " + _toDisplayString(item.phone), 1))
            : _createCommentVNode("", true),
          (__props.setData.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 收货地址：" + _toDisplayString(item.address), 1))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.goods), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.count), 1)
          ]),
          (__props.setData.paymentTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, "下单时间:" + _toDisplayString(item.paymentTime), 1),
                _createElementVNode("div", null, _toDisplayString(index + 1) + "/" + _toDisplayString(_unref(dataList).length), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_14
      ]))
    }), 128))
  ]))
}
}

})